<template>
  <div class="game-card">
    <!-- <img :src="cardImage" /> -->
    <!-- <div
      class="img-bg"
      :style="{ 'background-image': `url(${cardImage})` }"
    ></div> -->
    <div class="context">
      <div class="title">
        <span>{{ item.round ? item.round : `第${gameTime}轮` }}</span>
        <!-- <div class="icon"></div> -->
      </div>
      <div class="date">
        {{ item.data || item.date }} {{ item.time }} {{ item.week }}
      </div>
      <div class="record">
        <div class="home team-entry">
          <div class="image">
            <div
              class="img-bg icon"
              :style="{ 'background-image': `url(${home.image})` }"
            ></div>
            <!-- <img :src="home.image" /> -->
          </div>
          <div class="name">{{ home.name }}</div>
        </div>
        <div class="score">
          <span class="left">{{ home.score }}</span>
          <div class="middle">
            <img :src="require('@/assets/images/colon.svg')" />
          </div>
          <span class="right">{{ away.score }}</span>
        </div>
        <div class="away team-entry">
          <div class="image">
            <div
              class="img-bg icon"
              :style="{ 'background-image': `url(${away.image})` }"
            ></div>
            <!-- <img :src="away.image" /> -->
          </div>
          <div class="name">{{ away.name }}</div>
        </div>
      </div>

      <div class="btns">
        <div
          class="btn pre"
          @click="
            $emit('context', { type: true, id: item.id, round: item.round })
          "
        >
          赛事前瞻
        </div>
        <!-- <span class="line">|</span>
        <div class="btn live" @click="openLive">观看直播</div>
        <span class="line">|</span> -->
        <div
          class="btn after"
          @click="
            $emit('context', { type: false, id: item.id, round: item.round })
          "
        >
          赛后解盘
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GameCard',
  props: ['item', 'times'],
  methods: {
    openLive() {
      // $emit('play', item.url)
      const username = (function () {
        let result = ''
        const url = location.href.split('?')
        if (url.length > 1) {
          result = url[url.length - 1]
            .split('&')
            .map((e) => e.split('='))
            .filter((e) => e[0] === 'username')
          result = result.length ? result[0][1] : ''
        }
        return result
      })()
      const url = `https://m.fblivec.com/?${
        username ? 'username=' + username : ''
      }`
      window.open(url, '_blank')
    },
  },
  computed: {
    gameTime() {
      const arr = ' 一二三四五六七八九十'.split('')
      const num = (this.times + '').split('').map((e) => Number(e))
      const double = num.length >= 2
      let result = !double
        ? arr[num[0]]
        : (num[0] === 1 ? '' : arr[num[0]]) +
          arr[10] +
          (num[1] !== 0 && num[1] ? arr[num[1]] : '')
      return result
    },
    cardImage() {
      return require('../../assets/images/common/game.png')
    },
    home() {
      const item = this.item
      return {
        score: (item && item.home_scores) || 0,
        image:
          (item && item.home_image) ||
          require('../../assets/images/wolves/option.png'),
        name: (item && item.home_name) || '狼队',
      }
    },
    away() {
      const item = this.item
      return {
        score: (item && item.away_scores) || 0,
        image:
          (item && item.away_image) ||
          require('../../assets/images/wolves/option.png'),
        name: (item && item.away_name) || '狼队',
      }
    },
  },
}
</script>
<style lang="less" scoped>
.game-card {
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  background: #fff;
  border-radius: 4px;
  img {
    width: 100%;
    height: auto;
  }
  .img-bg {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    padding-bottom: 79.91071428571429%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    &.icon {
      padding-bottom: 100%;
    }
  }
  .context {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 0.4em;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 1em;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url('../../assets/images/title-bg.png') no-repeat left bottom;
      background-size: 100% 25%;
      width: 80px;
      margin-top: -37px;
      padding-bottom: 15px;
      font-size: 15px;
      span {
        margin-right: 0.3em;
      }
      div.icon {
        margin-top: -0.1em;
        background-image: url('../../assets/images/common/video.png');
        background-position: 50% 50%;
        background-size: 100%;
        background-repeat: no-repeat;
        font-size: 1em;
        width: 1em;
        height: 1em;
        display: inline-block;
      }
    }
    .date {
      font-size: 0.3em;
      font-weight: 400;
      text-align: center;
      margin-bottom: 0.8em;
      margin-top: 15px;
    }
    .record {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin-bottom: 0.5em;
      .team-entry {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 20%;
        .image {
          display: flex;
          width: 100%;
        }
        .name {
          font-size: 3vw;
          font-weight: 600;
          text-align: center;
        }
      }
      .score {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0.2em;
        font-size: 28px;
        .left {
          text-align: right;
        }
        .right {
          text-align: left;
        }
        & > span {
          // margin-top: -0.1rem;
        }
        .middle {
          width: 1rem;
          height: 1.1rem;
          display: inline-flex;
          justify-content: center;
          align-items: flex-start;
          text-align: center;
          // font-family: cursive;
          box-sizing: border-box;
          // font-family: Arial, Helvetica, san-serif;
        }
      }
    }
    .btns {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      font-size: 12px;
      background: #a8274b;
      color: #fff;
      padding :8px 0;
      .line {
        font-size: 12px;
      }
      .btn {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/items/GameCard.vue